export const APP_VERSION = "261016";
